import PropTypes from "prop-types";
import CategoryHeaderMedia from "../CategoryHeaderMedia";
import CategoryHeaderCopy from "./CategoryHeaderCopy";
import { VIDEO_HEADER } from "../constants";
import { getHeaderTitle } from "../CategoryHeader/helpers";
import styles from "./CategoryHeaderHero.css";
import getMediaUrls from "./getMediaUrls";
import getMediaType from "./getMediaType";

const CategoryHeaderHero = ({
  category,
  viewportCategory,
  isComingSoon,
  scrollFunction
}) => {
  const {
    headerTitle,
    friendlyName,
    headerHtmlEncoded,
    loyaltyBenefit,
    featuredHeader
  } = category;
  const header = getHeaderTitle({
    headerTitle,
    friendlyName,
    headerHtmlEncoded
  });

  const mediaUrls = getMediaUrls(featuredHeader);
  const mediaType = getMediaType({ viewportCategory, mediaUrls });

  return (
    <div id={VIDEO_HEADER} className={styles.heroHeader}>
      <div className={styles.heroHeaderContainer}>
        <CategoryHeaderMedia
          mediaType={mediaType}
          viewportCategory={viewportCategory}
          featuredHeaderData={featuredHeader}
        />
      </div>
      <CategoryHeaderCopy
        header={header}
        isComingSoon={isComingSoon}
        endDate={loyaltyBenefit.endDate}
        customerAccess={loyaltyBenefit.customerAccess}
        scrollFunction={scrollFunction}
      />
    </div>
  );
};

CategoryHeaderHero.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number,
    headerBody: PropTypes.string,
    friendlyName: PropTypes.string,
    headerHtmlEncoded: PropTypes.string,
    headerTitle: PropTypes.string,
    featuredHeader: PropTypes.object,
    loyaltyBenefit: PropTypes.shape({
      customerAccess: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  viewportCategory: PropTypes.string.isRequired,
  isComingSoon: PropTypes.bool.isRequired,
  scrollFunction: PropTypes.func.isRequired
};

export default CategoryHeaderHero;
